import Button from 'components/Button/Button';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteArrow,
  getDrawingToolControlData,
  getSelectedArrow,
  setSelectedArrow,
  updateArrow,
} from 'store/lixaniPaint/slices/drawingToolSlice';

export const ArrowSettings = () => {
  const dispatch = useDispatch();
  const controlData = useSelector(getDrawingToolControlData);
  const selectedArrow = useSelector(getSelectedArrow);

  const handleArrowColorChange = (e) => {
    if (!selectedArrow) return;
    dispatch(setSelectedArrow({ ...selectedArrow, lineColor: e.target.value }));
    dispatch(updateArrow({ ...selectedArrow, lineColor: e.target.value }));
  };

  const handleArrowWidthChange = (e) => {
    if (!selectedArrow) return;
    dispatch(
      setSelectedArrow({
        ...selectedArrow,
        lineWidth: parseInt(e.target.value),
      })
    );
    dispatch(
      updateArrow({ ...selectedArrow, lineWidth: parseInt(e.target.value) })
    );
  };

  const handleDeleteArrow = () => {
    if (selectedArrow) {
      dispatch(setSelectedArrow(null));
      dispatch(deleteArrow({ id: selectedArrow.id }));
    }
  };

  return (
    <div style={{ padding: '16px', color: 'white' }}>
      <div style={{ marginBottom: '16px' }}>
        <label
          style={{
            display: 'block',
            marginBottom: '8px',
            fontSize: '14px',
            fontWeight: '500',
          }}
        >
          Nuolen väri
        </label>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <input
            type="color"
            value={selectedArrow?.lineColor || controlData.lineColor}
            onChange={handleArrowColorChange}
            style={{
              width: '40px',
              height: '32px',
              border: '1px solid rgba(255,255,255,0.3)',
              borderRadius: '6px',
              backgroundColor: 'transparent',
              cursor: 'pointer',
            }}
          />
          <span style={{ fontSize: '13px', opacity: 0.8 }}>
            {selectedArrow?.lineColor || controlData.lineColor}
          </span>
        </div>
      </div>

      <div style={{ marginBottom: '16px' }}>
        <label
          style={{
            display: 'block',
            marginBottom: '8px',
            fontSize: '14px',
            fontWeight: '500',
          }}
        >
          Nuolen leveys
        </label>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <input
            type="range"
            min="1"
            max="10"
            value={selectedArrow?.lineWidth || controlData.lineWidth}
            onChange={handleArrowWidthChange}
            style={{
              flex: 1,
              height: '6px',
              borderRadius: '3px',
              background: 'rgba(255,255,255,0.2)',
              outline: 'none',
              cursor: 'pointer',
            }}
          />
          <span
            style={{
              minWidth: '40px',
              fontSize: '13px',
              fontWeight: '500',
              padding: '4px 8px',
              backgroundColor: 'rgba(255,255,255,0.1)',
              borderRadius: '4px',
              textAlign: 'center',
            }}
          >
            {selectedArrow?.lineWidth || controlData.lineWidth}px
          </span>
        </div>
      </div>

      {selectedArrow && (
        <Button
          onClick={handleDeleteArrow}
          color="danger"
          fullWidth
          size="small"
          style={{ marginTop: '8px' }}
        >
          Poista nuoli
        </Button>
      )}
    </div>
  );
};
